import { render } from "./TaskSchedulesPage.vue?vue&type=template&id=9a5b7e50"
import script from "./TaskSchedulesPage.vue?vue&type=script&lang=js"
export * from "./TaskSchedulesPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__